<template>
  <div>
    <!-- Profile Info -->
    <div class="profile">
      <div class="profile-inner">
        <img src="/static/img/profile1.jpg" alt="Profile Picture" class="profile-picture"/>
        <div style="justify-self: right;">
          <h2>Firstname</h2>
          <h2>Lastname</h2>
        </div>
      </div>
    </div>

    <!-- Network Health -->
    <GaugeComponent
        icon="plus"
        title="Network Health"
        :min="0"
        :max="100"
        :value="100"
        :show-footer="true"
    ></GaugeComponent>

    <!-- Widgets -->
    <div class="widgetContainer">
      <div class="widget">
        <div class="widget-inner" @click="goToPage('settings')">
          <font-awesome-icon :icon="['fas', 'cog']" class="widget-icon"/>
        </div>
      </div>
      <div class="widget">
        <div class="widget-inner" @click="goToPage('network')">
          <font-awesome-icon :icon="['fas', 'network-wired']" class="widget-icon"/>
        </div>
      </div>
      <div class="widget">
        <div class="widget-inner" @click="goToPage('filterBlocker')">
          <font-awesome-icon :icon="['fas', 'ban']" class="widget-icon"/>
        </div>
      </div>
    </div>
    <div class="widgetContainer">
      <div class="widget">
        <div class="widget-inner" @click="goToPage('devicesManager')">
          <font-awesome-icon :icon="['fas', 'laptop']" class="widget-icon"/>
        </div>
      </div>
      <div class="widget">
        <div class="widget-inner" @click="goToPage('accounts')">
          <font-awesome-icon :icon="['fas', 'users']" class="widget-icon"/>
        </div>
      </div>
      <div class="widget">
        <div class="widget-inner" @click="goToPage('networkStats')">
          <font-awesome-icon :icon="['fas', 'chart-column']" class="widget-icon"/>
        </div>
      </div>
    </div>
    <MessageModal :message="appMessage.text" :type="appMessage.type" ref="messageModal" />
  </div>
</template>

<script>
import GaugeComponent from "@/components/Gauge.vue";
import MessageModal from "@/components/MessageModal.vue";

export default {
  name: 'ProfilePage',
  components: {MessageModal, GaugeComponent},
  data(){
    return {
      appMessage: {
        text: '',
        type: 'error',
      },
    }
  },
  mounted(){

  },
  methods: {
    goToPage(name){
      this.$router.push({
        name
      })
    },
  },
}
</script>

<style scoped>
.profile {
  width: 110%;
  height: fit-content;
  margin-bottom: 30px;
  position: relative;
  left: -30px
}
.profile-inner {
  display: inline-block;
  width: 100%;
  height: fit-content;
  justify-content: left;
  align-content: center;
  padding: 15px 30px;
  background-color: var(--color-card);
  border-style: solid;
  border-width: 2px;
  border-color: var(--color-card-border);
  border-radius: 16px;
  position: relative;
}
.profile-picture {
  display: inline-block;
  width: 140px;
  height: 120px;
  border: solid 3px var(--color-card-border);
  border-radius: 8px;
  position: absolute;
  top: 15px;
  left: -10px;
}
.widgetContainer{
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  gap: 15px;
}
.widget-table {
  width: 100%;
  justify-self: center;
  align-items: center;
  border-collapse: separate;
  border-spacing: 15px;
}
.widget {
  display: flex;
  justify-content: center;
  align-items: center;
}
.widget-inner {
  width: 100%;
  height: 100%;
  justify-content: center;
  align-content: center;
  padding: 23px;
  background-color: var(--color-card);
  border-style: solid;
  border-width: 2px;
  border-color: var(--color-card-border);
  border-radius: 16px;
}
.widget-icon {
  width: 100%;
  height: 100%;
  color: var(--permanent-white);
}
</style>